import { render, staticRenderFns } from "./im-image-message.vue?vue&type=template&id=644202a2&scoped=true"
import script from "./im-image-message.vue?vue&type=script&lang=js"
export * from "./im-image-message.vue?vue&type=script&lang=js"
import style0 from "./im-image-message.vue?vue&type=style&index=0&id=644202a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644202a2",
  null
  
)

export default component.exports